//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  props: ['length'],
  name: 'progressbar',
  data() {
    return {
      maxwidth: 0
    };
  },
  methods: {},
  watch: {},
  computed: {},
  created() {},
  mounted() {
    let maxwidth = document.querySelector('.bar-color').clientWidth;
    this.maxwidth = maxwidth * this.length * 0.01;
    console.log(this.maxwidth);
  }
};
